export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Overhead%20flatlay%20of%20curated%20streetwear%20items%20on%20raw%20linen%20texture%2C%20white%20sneakers%20grey%20hoodie%20black%20cap%20silver%20watch%20arranged%20organically%2C%20morning%20sunlight%20casting%20long%20soft%20shadows%2C%20warm%20beige%20and%20cream%20palette%2C%20editorial%20minimal%20fashion%20photography%2C%20generous%20empty%20center%20space&width=1920&height=1080&seq=hero-main-v2-2026&orientation=landscape"
        alt="Sugargoo Spreadsheet featured fashion products flatlay"
        title="Sugargoo Spreadsheet - Best Updated Finds 2026"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 pt-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading italic text-white leading-tight tracking-tight">
            Best Sugargoo<br />
            <span className="text-primary-300">Spreadsheet</span> 2026
          </h1>
          <p className="mt-6 text-sm md:text-base text-white/85 max-w-xl mx-auto leading-relaxed">
            Discover the most updated Sugargoo Spreadsheet for sneakers, clothing, accessories, and designer finds. Every link is community-vetted and QC-checked before listing.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Sugargoo Spreadsheet
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-white/80 text-white rounded-full text-sm font-semibold hover:bg-white hover:text-foreground-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-cart-line text-lg"></i>
            </a>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {[
              { label: 'Updated Daily', icon: 'ri-refresh-line' },
              { label: 'QC Checked', icon: 'ri-shield-check-line' },
              { label: 'Budget Friendly', icon: 'ri-money-dollar-circle-line' },
              { label: 'Community Picks', icon: 'ri-group-line' },
            ].map((feature) => (
              <div key={feature.label} className="flex flex-col items-center gap-2">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15">
                  <i className={`${feature.icon} text-white text-lg`}></i>
                </span>
                <span className="text-xs md:text-sm text-white/85 font-medium whitespace-nowrap">
                  {feature.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}